import React,{Component} from 'react';
// import {Link} from 'react-router';


const baseAssets = 'https://aquadeals.in/admin/assets/';
class Close_ad extends Component{
constructor(props){
    super(props);
    this.state={
      showOpenApp: "",
      showCloseApp: 1
    }
  }

  componentDidMount()
  {
      var checkCloseAd = this.getCookie('closeAd');
      if(typeof(checkCloseAd)  === "undefined"){
        this.state.showCloseApp = 0;
      }
  }

  show_footer(){
    this.setState({ showOpenApp: "close" });
    this.createCookie('closeAd',1,1);
    var closeAd = this.getCookie('closeAd');
    //console.log(closeAd);
    this.setState({ showCloseApp: closeAd });
  }

createCookie(name, value, days) {
    var date, expires;
    if (days) {
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

render(){


var footer = '';
if(this.state.showCloseApp === 0){


footer= (
<div className="row">
  <div className="col-lg-8 col-xs-8 col-sm-8 desc-div">
        <div className="flex-container-smart-banner">
            <img onClick={this.show_footer.bind(this)} className="smart-close-btn-android" src="https://www.bigbasket.com/content/images/svg/android-close.svg" />
            <img className="smart-logo logo-android" src="https://aquadeals.in/admin/assets/images/web_imgs/ad_icon.png" />
            <div className="flex-column-container-smart-banner">    
            <span className="smart-desc">Experience AquaDeals Mobile App</span>
            {/*<span className="smart-desc-sub">Donwnload from play store</span>*/}
            </div>
        </div>
  </div>
  <div className="col-lg-4 col-xs-4 col-sm-4 flex-container-smart-banner" >
        <div className="android-use-btn">
            <a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en">
            <img className="smart-logo logo-android" src="https://aquadeals.in/admin/assets/images/web_imgs/get_app_icon.png" />
            </a>
        </div>
  </div>  
</div>)



}else{
  footer = '';
}
  return (
    <div>
      {footer}
    </div>);
    }
}
export default Close_ad;



/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/close_ad.js
 **/